/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// this will be used to gauge the amount of time a user has spent for a given event fired by tracking
export default class Timer {
	startTime = null;
	start() {
		this.startTime = new Date();
	}
	end() {
		return new Date() - this.startTime;
	}
};
